module.exports = __webpack_public_path__ + "img/chat_bianca.bda0b049.png";